import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Profile } from 'core/models/agent';
import { AgentsService, ProfileService } from 'core/services';

export const AgentResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  agentsService: AgentsService = inject(AgentsService),
  profileService: ProfileService = inject(ProfileService),
  router: Router = inject(Router)
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const agentId = route.paramMap.get('agentId') || route.queryParamMap.get('agentId');
    const loggedUser: Profile = profileService.getLoggedUser();

    if (agentId) {
      if (loggedUser && loggedUser.id === agentId) {
        resolve(loggedUser);
      } else {
        agentsService.getAgent(agentId).subscribe({
          next: (remoteAgent) => {
            resolve(remoteAgent);
          },
          error: (err) => {
            reject(err);
            router.navigate(['error']).then();
          }
        });
      }
    } else {
      resolve(null);
    }
  });
};
